import { FC } from 'react';

import { ActionPanel, Stack, Typography } from '@thirdspacelearning/library';

import notFoundSvg from '../assets/not-found.svg';

type Props = {
    logout: () => void;
};

const Unauthorised: FC<Props> = ({ logout }) => {
    return (
        <Stack
            sx={{
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                bgcolor: 'background.default',
            }}
        >
            <ActionPanel
                type="error"
                decoration={
                    <img
                        src={notFoundSvg}
                        alt="Unauthorised access"
                        width="250px"
                    />
                }
                title="Something doesn't add up"
                textContent={
                    <Typography align="center">
                        Looks like you’re trying to reach the wrong part of our
                        site. Please check you are accessing the correct
                        application and are using the right credentials.
                    </Typography>
                }
                buttonLabel="Logout"
                buttonAction={logout}
                sx={{ maxWidth: '410px' }}
            />
        </Stack>
    );
};

export default Unauthorised;
